export const ALDETRE_SCORE = {
  masterTableName: "MC_MODIFIED_SCORE",
  tableName: "MC_MODIFIED_SCORE_DETAIL",
  columnName: "MS_ID",
  columnValue: 0,
  title: "modified-aldrete.title",
  rows: [
    {
      title: "id",
      value: "ID",
    },
    {
      title: "date",
      value: "PROCESS_TIME",
      headerName: "Tarih",
    },
    {
      title: "LEVEL_CONSCIOUSNESS",
      value: "LEVEL_CONSCIOUSNESS_XNAME",
    },
    {
      title: "ACTIVITY",
      value: "ACTIVITY_XNAME",
    },
    {
      title: "RESPIRATORY",
      value: "RESPIRATORY_XNAME",
    },
    {
      title: "SPO2",
      value: "SPO2_XNAME",
    },
    {
      title: "BLOOD_PRESSURE",
      value: "BLOOD_PRESSURE_XNAME",
    },
    {
      title: "PULSE",
      value: "PULSE_XNAME",
    },
    {
      title: "MAS_SCORE",
      value: "MAS_SCORE",
    },
  ],
  fields: [
    { field: "date", headerName: "datetime", flex: 1 },
    {
      field: "LEVEL_CONSCIOUSNESS",
      headerName: "modified-aldrete.level_consciousness",
      flex: 1,
    },
    { field: "ACTIVITY", headerName: "modified-aldrete.activity", flex: 1 },
    {
      field: "RESPIRATORY",
      headerName: "modified-aldrete.respiratory",
      flex: 1,
    },
    { field: "SPO2", headerName: "modified-aldrete.spo2", flex: 1 },
    {
      field: "BLOOD_PRESSURE",
      headerName: "modified-aldrete.blood_pressure",
      flex: 1,
    },
    { field: "PULSE", headerName: "modified-aldrete.pulse", flex: 1 },
    {
      field: "MAS_SCORE",
      headerName: "modified-aldrete.mas-score",
      flex: 1,
      computed: false,
      calculate: (row: any) => {
        if (!row) return 0;

        const level_consciousness =
          Number(row.LEVEL_CONSCIOUSNESS_XVALUE) || 0;
        const activity = Number(row.ACTIVITY_XVALUE) || 0;
        const respiratory = Number(row.RESPIRATORY_XVALUE) || 0;
        const spo2 = Number(row.SPO2_XVALUE) || 0;
        const blood_pressure = Number(row.BLOOD_PRESSURE_XVALUE) || 0;
        const pulse = Number(row.PULSE_XVALUE) || 0;

        const totalScore =
          level_consciousness +
          activity +
          respiratory +
          spo2 +
          blood_pressure +
          pulse;

        return totalScore;
      },
    },
  ],
  mcpConfig: {
    LEVEL_CONSCIOUSNESS: {
      mcpId: 831,
      field: "LEVEL_CONSCIOUSNESS",
      scoreField: "LEVEL_CONSCIOUSNESS_XVALUE",
    },
    ACTIVITY: {
      mcpId: 832,
      field: "ACTIVITY",
      scoreField: "ACTIVITY_XVALUE",
    },
    RESPIRATORY: {
      mcpId: 833,
      field: "RESPIRATORY",
      scoreField: "RESPIRATORY_XVALUE",
    },
    SPO2: { mcpId: 834, field: "SPO2", scoreField: "SPO2_XVALUE" },
    BLOOD_PRESSURE: {
      mcpId: 835,
      field: "BLOOD_PRESSURE",
      scoreField: "BLOOD_PRESSURE_XVALUE",
    },
    PULSE: { mcpId: 836, field: "PULSE", scoreField: "PULSE_XVALUE" },
  } as Record<string, { mcpId: number; field: string; scoreField: string }>,
  formData: {
    MS_ID: "",
    CTIME: new Date(),
    PROCESS_TIME: new Date(),
    CUSER: "",
    LEVEL_CONSCIOUSNESS: "",
    ACTIVITY: "",
    RESPIRATORY: "",
    SPO2: "",
    BLOOD_PRESSURE: "",
    PULSE: "",
    MAS_SCORE: "",
  },
  chartScoreField: "MAS_SCORE",
  chartTimeField: "PROCESS_TIME",
};
